export const vertSampler = `
precision mediump float;

attribute vec2 inPosition;
attribute vec2 inTexCoord;

varying vec2 outTexCoord;

uniform mat4 uTransformMatrix;

void main ()
{
  gl_Position = uTransformMatrix * vec4(inPosition, 0, 1.0);

  outTexCoord = inTexCoord;
}
`;
